import React, { useEffect, useRef, useState } from 'react';
import { Protected } from '@components/layout/Protected';
import { Loading } from "@components/common/Loading";
import { Alert, Backdrop, CircularProgress, Container, Divider, Grid, IconButton, Menu, MenuItem, Snackbar, Breadcrumbs } from "@mui/material";
import { TableDataV2 } from '@/components/common/Tablev2';
import { ModalCompanyDelete } from '@/components/Modal/ModalCompanyDelete';
import { Props } from './Products.type';
import { ProductService } from '@/service/services/Products.service';
import { ModalProduct } from '@/components/Modal/ModalProduct/ModalProducts';
import { emphasize, styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import GroupsIcon from '@mui/icons-material/Groups';
import { ModalProductMovement } from '@/components/Modal/ModalProductMovement/ModalProductMovements';
import ___PHRASE from '@/service/translate/translateService';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
        theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800];
    return {
        backgroundColor,
        height: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(backgroundColor, 0.12),
        },
    };
 });


export const ProductsView: React.FC<Props> = (props:any): JSX.Element => {

    const [loading, setLoading] = useState<boolean>(false);
    const [products, setProducts] = useState<any>([]);
    const [showProductModal, setShowProductModal] = useState<boolean>(false);
    const [showProductDeleteModal, setShowProductDeleteModal] = useState<boolean>(false);
    const [actionSelected, setActionSelected] = useState<any>('');
    const [productSelected, setProductSelected] = useState<any>('');

    const [purchases, setPurchases] = useState<any>([]);
    const [showPurchaseModal, setShowPurchaseModal] = useState<boolean>(false);
    const [purchaseSelected, setPurchaseSelected] = useState<any>('');
    const [showPurchases, setShowPurchases] = useState<boolean>(false);
    const [view, setView] = useState<String>('products');

    const [movement, setMovement] = useState<any>([]);
    const [showMovementModal, setShowMovementModal] = useState<boolean>(false);
    const [showMovement, setShowMovement] = useState<boolean>(false);
    const [movementSelected, setMovementSelected] = useState<any>('');

    const headerProducts = [
        { name: 'name', label: ___PHRASE("nombre"), filter: false, Chip: true },
        { name: 'brand', label: ___PHRASE("modelo"), filter: false, Chip: false },
        { name: 'description', label: ___PHRASE("descripcion"), filter: false, Chip: false },
        { name: 'statusDescription', label: ___PHRASE("estado"), filter: false, Chip: false },
    ]
    const cabeceraPurchases = [
        { name: 'num_doc', label: ___PHRASE("nDocumento") },
        { name: 'date_purchase', label: ___PHRASE("fechaDeCompra") },
        { name: 'model', label: ___PHRASE("modelo") },
        { name: 'net_cost', label: ___PHRASE("netCost") },
        { name: 'status_initial', label: ___PHRASE("estadoInicial") },
        { name: 'estimated_duration', label: ___PHRASE("duracionEstimada") },
     ];
  
     const cabeceraMovements = [
        { name: 'type_movement', label: ___PHRASE("tipoDeMovimiento") },
        { name: 'date', label: ___PHRASE("fecha") },
        { name: 'agreed_return_date', label: ___PHRASE("fechaDeRetornoAcordado")},
     ];

    useEffect(() => {
        getProducts();
    },[]);

    useEffect(()=> {
        if(productSelected && actionSelected=='helper' && view=='purchases'){
            purchasesByProdyct(productSelected.id);
        }
    },[productSelected]);
  
     useEffect(()=> {
        if(purchaseSelected && actionSelected=='helper' && view=='movements'){
            movementsByPurchase(purchaseSelected.id);
        }
    },[purchaseSelected]);

    const getProducts = async () => {
        setLoading(true);
        const response = await ProductService.getProducts();
        if (response.data) {
            ////
            const oldData = response.data  || [];
            let newData = [];
            oldData.length > 0 && oldData.map((item) => {
                let obj = {
                    id: item.id,
                    brand: item.brand,
                    description: item.description,
                    idcompany: item.idcompany,
                    name: item.name,
                    status: item.status,
                    statusDescription: item.status == '3' ? 'Dado de Baja' : 'Activo',
                }
                newData.push(obj);
            });
            setProducts(newData || []);
        } else {
            console.log('error')
        }
        setLoading(false);
    }

    const purchasesByProdyct = async(idProduct) => {
        setLoading(true);
        await ProductService.purchasesByProdyct(idProduct).then((data) => {
            setPurchases(data.data || []);
           setLoading(false);
        })
    }

    const movementsByPurchase = async(idPurchase) => {
        setLoading(true);
        await ProductService.movementsByPurchase(idPurchase).then((data) => {
            setMovement(data.data || []);
           setLoading(false);
        })
    }

    function RecuperarData(value){
        console.log(value);

        !productSelected && setProductSelected(value);
        productSelected && view=='purchases' && setPurchaseSelected(value);
        productSelected && purchaseSelected && view=='movements' && setMovementSelected(value);

        if(value.action == "helper" && view=='products'){
            setShowPurchases(true);
            setView('purchases');
        }else if(value.action == "helper" && view=='purchases'){
            setShowMovement(true);
            setView('movements');
        }
    }

    const searchData = async (value) => {
        const response = await ProductService.getProducts(value);
        if (response.data) {
            ////
            const oldData = response.data  || [];
            let newData = [];
            oldData.length > 0 && oldData.map((item) => {
                let obj = {
                    id: item.id,
                    brand: item.brand,
                    description: item.description,
                    idcompany: item.idcompany,
                    name: item.name,
                    status: item.status,
                    statusDescription: item.status == '3' ? 'Dado de Baja' : 'Activo',
                }
                newData.push(obj);
            });
            setProducts(newData || []);
        } else {
            console.log('error')
        }
    }

    return (
        <Protected>
            {loading && <Loading/>}

            <Container>

                <Breadcrumbs aria-label="breadcrumb" sx={{mt:3, ml:2}}>
                <StyledBreadcrumb
                    label={___PHRASE("listaDeMateriales")}
                    onClick={() => {
                        setView('products');
                        setProductSelected('');
                        setShowPurchases(false);
                        setShowMovement(false);
                    }}
                    icon={<GroupsIcon fontSize="small" />}
                />
                {
                    showPurchases && (
                        <StyledBreadcrumb
                            label={___PHRASE("comprasPorMaterial")}
                            onClick={() => {
                                setView('purchases');
                                setPurchaseSelected('');
                                setShowMovement(false);
                            }}
                            icon={<GroupsIcon fontSize="small" />}
                        />
                    )
                }
                {
                    showMovement && (
                        <StyledBreadcrumb
                            label={___PHRASE("movimientosDeLaCompra")}
                            onClick={() => {setView('movements')}}
                            icon={<GroupsIcon fontSize="small" />}
                        />
                    )
                }
                </Breadcrumbs>

                {
                    view == 'products' && (
                        <TableDataV2
                        title={___PHRASE("materiales")}
                        data={products || []}
                        header={headerProducts}
                        actionSelect={setActionSelected}
                        setModalSave={setShowProductModal}
                        setModalDelete={setShowProductDeleteModal}
                        btn_delete_disable={true}
                        btn_helper
                        status_action
                        textSearch={___PHRASE("buscarMaterial")}
                        searchData={searchData}
                        RecuperarData={RecuperarData}
                        />
                    )
                }

                {
                    view == 'purchases' && (
                        <TableDataV2
                        title={___PHRASE("compras")}
                        data={purchases || []}
                        header={cabeceraPurchases}
                        actionSelect={setActionSelected}
                        setModalSave={setShowPurchaseModal}
                        btn_delete_disable={true}
                        btn_edit_disable={true}
                        btn_helper
                        btn_disabled
                        status_action
                        RecuperarData={RecuperarData}
                        />
                    )
                }

                {
                    view == 'movements' && (
                        <TableDataV2
                        title={___PHRASE("movimientos")}
                        data={movement || []}
                        header={cabeceraMovements}
                        actionSelect={setActionSelected}
                        setModalSave={setShowMovementModal}
                        btn_delete_disable={true}
                        btn_disabled
                        status_action
                        RecuperarData={RecuperarData}
                        />
                    )
                }

            </Container>

            { 
                showProductModal && (
                <ModalProduct
                    open={showProductModal}
                    closeModal={()=>{setShowProductModal(false)}}
                    actionSelected={actionSelected}
                    onListProduct={getProducts}
                    product={productSelected}
                    clearState={()=>{setProductSelected('')}}
                />
                )
            }
            {
                actionSelected === 'delete' && (
                <ModalCompanyDelete
                    open={showProductDeleteModal}
                    closeModal={()=>{setShowProductDeleteModal(false)}}
                    actionSelected={actionSelected}
                    onListCompanies={getProducts}
                    company={productSelected}
                    clearState={()=>{setProductSelected('')}}
                />
                )
            }
            {
                (showMovementModal && view == 'movements') && (
                <ModalProductMovement
                    open={showMovementModal}
                    closeModal={()=>{setShowMovementModal(false)}}
                    actionSelected={actionSelected}
                    onListMovements={movementsByPurchase}
                    movement={movementSelected}
                    purchaseSelected={purchaseSelected}
                    clearState={()=>{setMovementSelected('')}}
                    type={'changebranchoffice'}
                />
                )
            }
        
        </Protected>
    )
};